module.exports = {
  BOTH: "Both",
  IOS: "iOS",
  ANDROID: "Android"
};
